import { LayoutAnimation } from 'react-native';

export const setNextLayoutAnimation = () => {
  LayoutAnimation.configureNext({
    create: {
      property: LayoutAnimation.Properties.opacity,
      type: LayoutAnimation.Types.easeInEaseOut,
    },
    duration: 250,
    update: {
      type: LayoutAnimation.Types.easeInEaseOut,
    },
  });
};
